import "./index.less";
import React from "react";
import Panel from "@/components/Panel";
import { useGlobalStore } from "@/store/hooks";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import ShopType from "@/enum/ShopType";
import { wangwangService } from "@/services/customerServices";

import { AllPlatform, PddPlatform, TbPlatform } from "./data";

function buildTaobaoPlatformLinks() {
    return TbPlatform.map(({ to, alt, image }, index) => (
        <Link to={to} className="platform-item" key={index}>
            <img alt={alt} src={image} />
        </Link>
    ));
}

function buildPDDPlatformLink() {
    return PddPlatform.map(({ to, alt, image }, index) => (
        <Link to={to} className="platform-item" key={index}>
            <img alt={alt} src={image} />
        </Link>
    ));
}

function buildOtherPlatformLinks() {
    return AllPlatform.map(({ to, alt, image }, index) => (
        <Link to={to} className="platform-item" key={index}>
            <img alt={alt} src={image} />
        </Link>
    ));
}

/**
 * 构建平台链接
 */
function buildPlatformLinks(shopType: ShopType) {
    switch (shopType) {
        case ShopType.ALIBABA:
        case ShopType.TAOBAO:
        case ShopType.TAOBAO_DISTRIBUTION:
        case ShopType.ALI_C2M:
            return buildTaobaoPlatformLinks();
        case ShopType.PINDUODUO:
        case ShopType.PDD_FDS:
        case ShopType.PDD_FULFILLMENT:
            return buildPDDPlatformLink();
        default:
            return buildOtherPlatformLinks();
    }
}

/**
 * 支持的平台类型 卡片栏
 */
const PlatformCard: React.FC = observer(() => {
    const { currentUser, shopMapping, allowedShops } = useGlobalStore();

    const shopType = shopMapping.get(currentUser?.shopId)?.type;

    const firstManualShopId = allowedShops.find(({ type }) => type === ShopType.MANUAL)?.id;

    return (
        <Panel title="支持平台" className="mb20">
            <div className="p15">
                <div className="ec-support-platform-container">
                    {buildPlatformLinks(shopType)}

                    <Link
                        className="platform-item"
                        to={
                            firstManualShopId
                                ? `/manualOrder/import?shopId=${firstManualShopId}`
                                : "/setting/shop/add/platform?type=MANUAL"
                        }
                    >
                        <img
                            alt="导入订单"
                            src="//img.alicdn.com/imgextra/i1/54458674/O1CN01DdHSP32DwkANNlPVW_!!54458674.jpg"
                        />
                    </Link>

                    <Link to="/partnership/login" className="platform-item">
                        <img
                            alt="发货易分销版"
                            src="//img.alicdn.com/imgextra/i2/54458674/O1CN01nk9AGl2DwkDL6tytF_!!54458674.png"
                        />
                    </Link>
                </div>

                <div className="tc p10 text-small text-black">
                    发货易支持20多个电商平台，其他平台请
                    {import.meta.env.VITE_IS_QN ? (
                        <a href={wangwangService.url} target="_blank">
                            联系客服咨询
                        </a>
                    ) : (
                        <Link to="/cs">联系客服咨询</Link>
                    )}
                </div>
            </div>
        </Panel>
    );
});

export default PlatformCard;
